export function usePromiseManager() {
  const holder = {};
  return {
    issuPromise(key){
      return new Promise((resolve, reject) => {
        holder[key] = {
          key,
          resolve,
          reject,
        };
      });
    },
    resolvePromise(key, obj){
      if(holder[key]){
        holder[key].resolve(obj);
        delete holder[key];
      }
    },
    rejectPromise(key, obj){
      if(holder[key]){
        holder[key].reject(obj);
        delete holder[key];
      }
    },
  }
}
